import mcDonalds from "./themes/mcDonalds";
import iteam from "./themes/iteam";
import starbucks from "./themes/starbucks";
import tennant from "./themes/tennant";

export const themes = {
  iteam,
  mcDonalds,
  starbucks,
  tennant,
};

export default function getTheme(theme) {
  const res = themes[theme];
  return res;
}
